import { Icon, Text, Button } from "@ui-component-library";
import MediaSelector from "../editor/fields/MediaSelector";
import ColorSelector from "../editor/fields/ColorSelector";

const HeroBigImage = (props) => {
  
  const variantClass = !props.variant || props.variant == "default" ? "min-h-screen" : "min-h-[150vh] pb-80";

  return (
    <>
      <div
        className={`w-full ${props.backgroundColor} bg-cover ${props.backgroundImagePosition}`}
        style={{
          backgroundImage: props.gradientOverlay && props.gradientOverlay !== "none"
          ? `${props.gradientOverlay}, url("${props.backgroundImage}")`
          : `url("${props.backgroundImage}")`
        }}
      >
        <section className={`w-full py-3 container flex items-center justify-center ${variantClass}`}>
          <div className="w-[576px] px-2 max-w-full flex items-center justify-center flex-wrap">
            {props.sectionName && <Text variant="text-sm/leading-none/medium" className="text-[#FBFBFB] w-full text-center mb-8">{props.sectionName}</Text>}

            {props.mainText && <Text variant="text-4xl/leading-normal/medium" className="lg:text-7xl text-spring-yellow-500 w-full text-center mb-8">{props.mainText}</Text>}

            {props.subText && <Text variant="text-lg/leading-normal/normal" className="text-white-50 w-full text-center mb-8">{props.subText}</Text>}

            {props.buttonText && <Button variant="primary" onClick={() => {window.location.href=props.buttonHref;}}>
              {props.buttonText}
              <Icon tw name="ArrowRightSimple" className="fill-white-500" />
            </Button>}
          </div>
        </section>

        {props.variant === "extended" && (
          <section className="container flex justify-center items-center pb-48">
            <div className="w-[768px]">
              <Text tw variant="text-4xl/leading-normal/medium" className="text-white-50 w-full text-center mb-8">{props.extendedText}</Text>
              <Text tw variant="text-4xl/leading-normal/medium" className="text-spring-yellow-500 text-center">{props.extendedSlogan}</Text>
            </div>
          </section>
      )}
      </div>
    </>
  );
};

HeroBigImage.defaultProps = {
  variant: "default",
  sectionName: "Hero Big Image",
  mainText: "Framtidens skogsägande börjar här",
  subText: "Få full kontroll över din fastighet. Treebula ger dig alla möjligheter att fatta trygga beslut och optimera din skogs framtid.",
  buttonHref: "/min-skog/",
  buttonText: "Kom igång",
  // stretchBackgroundImage: null, // unused in render
  backgroundImagePosition: 'bg-center-center',
  backgroundColor: 'white-50',
  gradientOverlay: "none",
  extendedText: "Skogen rymmer stora värden och många möjligheter, men de är inte alltid enkla att se eller ta tillvara på.",
  extendedSlogan: "Där finns Treebula.",
};

HeroBigImage.resolveFields = (data) => {
  const fields = {
    variant: {
      type: "select",
      label: "Variant",
      options: [
        { label: "Default", value: "default" },
        { label: "Extended", value: "extended" },
      ],
    },
    sectionName: {
      type: "text",
      label: "Section Name",
    },
    mainText: {
      type: "textarea",
      label: "Main Text",
    },
    subText: {
      type: "textarea",
      label: "Sub Text",
    },
    buttonText: {
      type: "text",
    },
    buttonHref: {
      type: "text",
    },
    backgroundImage: {
      type: "custom",
      render: ({ name, onChange, value }) => <MediaSelector name={name} onChange={onChange} value={value} />,
    },
    backgroundImagePosition: {
      type: "select",
      options: ["top", "bottom", "center"].reduce((acum, item) => {
          ["left", "right", "center"].forEach((item2) => {
              acum.push({label:"bg-"+item+"-"+item2, value:"bg-"+item+"-"+item2})
          })
          return acum;
      }, [{label:"bg-top", value:"bg-top"}, {label:"bg-bottom", value:"bg-bottom"}, {label:"bg-center", value:"bg-center"}, {label:"bg-left", value:"bg-left"}, {label:"bg-right", value:"bg-right"}])
    }, 
    backgroundColor: {
      type: "custom",
      render: (props) => <ColorSelector {...props} />
    },
    gradientOverlay: {
      type:"select",
      options: [
        { label: "None", value: "none" },
        { label: "Linear overlay (50%)", value: `var(--background-image-linear-overlay-50, transparent)` }, 
      ],
    }
  }

  if (data.props.variant === "extended") {
    return {
      ...fields,
      extendedText: {
        type: "textarea",
        label: "Extended Text",
      },
      extendedSlogan: {
        type: "textarea",
        label: "Extended Slogan",
      },
    }
  }

  return fields;
};

export default HeroBigImage;
